function assignDotKeyValue(data, names) {
  for (const key of names) {
    const path = key.match(/(.+)\.(.+)/);
    if (!path) continue;

    data[key] = data[path[1]] && data[path[1]][path[2]] ? data[path[1]][path[2]] : '';
  }
}

module.exports = {
  assignDotKeyValue,
};
